












import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlusCircle, faPencil } from '@fortawesome/pro-light-svg-icons';
import { RouteState } from '@/types';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

library.add(faPlusCircle, faPencil);

@Component({ name: 'resource-create' })
export default class ResourceCreate extends Vue {
  @State(state => state.route)
  currRoute!: RouteState;

  @Prop({ type: String, default: 'New' })
  text!: string;

  @Prop({ type: [Object, String] })
  route!: [Object, String];

  get thisRoute() {
    return this.route ? this.route : `${this.currRoute.name}/create`;
  }

  get isEditAction() {
    return this.text.toLowerCase().includes('edit');
  }
}
